export enum RouteNames {
  DatapoolDetails = 'DatapoolDetails',
  Datapools = 'Datapools',
}
